import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCreditMemos = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 32,
	height: 32,
	fill: "none",
	viewBox: "0 0 32 32",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M20 13h-8c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1Zm0 4h-8c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1Zm-4 2h-4c-.55 0-1 .45-1 1s.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1Z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M26 4c.53 0 1.03.21 1.41.59h.01c.38.37.59.88.59 1.41v13.58c0 .26-.05.51-.15.76-.01 0-.01.02-.01.02-.003.007-.008.013-.012.02-.01.013-.018.027-.018.04-.09.2-.22.39-.38.56l-6.43 6.43c-.17.17-.36.29-.57.39-.007.003-.013.008-.02.012-.013.01-.027.018-.04.018-.01.01-.02.02-.03.02-.24.1-.49.15-.75.15H6c-.53 0-1.03-.22-1.41-.59C4.21 27.04 4 26.53 4 26V6c0-.53.22-1.03.59-1.41C4.96 4.21 5.47 4 6 4h20Zm0 2H6v20h13v-6c0-.55.45-1 1-1h6V6Zm-5 18.59L24.59 21H21v3.59Z",
		clipRule: "evenodd"
	})]
});
export default SvgCreditMemos;
